import React from "react";
import { getColourCss, getFontSizeCss } from "@helpers/css-convertions";
import Container from "@ui/container";

const WrapWithStyle = ({ data, children }) => {
    if (!data) return <>{children}</>;

    const styleMargin = data.margin
        ? {
              marginTop: data.margin.top ? `${data.margin.top}px` : null,
              marginBottom: data.margin.bottom
                  ? `${data.margin.bottom}px`
                  : null,
              marginLeft: data.margin.left ? `${data.margin.left}px` : null,
              marginRight: data.margin.right ? `${data.margin.right}px` : null,
          }
        : {};

    const stylePadding = data.padding
        ? {
              paddingTop: data.padding.top ? `${data.padding.top}px` : null,
              paddingBottom: data.padding.bottom
                  ? `${data.padding.bottom}px`
                  : null,
              paddingLeft: data.padding.left ? `${data.padding.left}px` : null,
              paddingRight: data.padding.right
                  ? `${data.padding.right}px`
                  : null,
          }
        : {};

    const styleBorder = data.border
        ? {
              borderTopWidth: data.border.top ? `${data.border.top}px` : null,
              borderBottomWidth: data.border.bottom
                  ? `${data.border.bottom}px`
                  : null,
              borderLeftWidth: data.border.left
                  ? `${data.border.left}px`
                  : null,
              borderRightWidth: data.border.right
                  ? `${data.border.right}px`
                  : null,
              borderRadius: data.border.radius
                  ? `${data.border.radius}px`
                  : null,
          }
        : {};

    const styleWidth = data.width
        ? {
              maxWidth: data.width.maxWidth ? `${data.width.maxWidth}px` : null,
              minWidth: data.width.minWidth ? `${data.width.minWidth}px` : null,
              width: data.width.widthInPercent
                  ? `${data.width.widthInPercent}%`
                  : data.width.width
                  ? `${data.width.width}px`
                  : null,
          }
        : {};

    const bgColour = data.background &&
        data.background.colour &&
        data.background.colour == 'PrimaryLight'
            ? 'rgba(242,248,255,1)'
            :  '';

    const backgroundStyle = data.background
        ? {
              background:
                  data.background.colour && data.background.percent
                      ? "rgb(255,255,255)"
                      : bgColour,
              backgroundImage:
                  data.background.colour && data.background.percent
                      ? `linear-gradient(0deg, rgba(255,255,255,1) ${data.background.percent}%, ${bgColour} ${data.background.percent}%)`
                      : null,
          }
        : {};

    const style = {
        ...(data.border?.isForContentArea ? {} : styleBorder),
        ...styleMargin,
        ...stylePadding,
        ...(data.wrapInContentArea ? {} : styleWidth),
        ...backgroundStyle,
    };

    const fontCss = getFontSizeCss(data.fontSize) ?? "";
    const borderCss = data.border?.isForContentArea
        ? ""
        : data.border?.colour
        ? getColourCss(data.border.colour)
        : "";

    const styleBorderForContentArea = data.border?.isForContentArea
        ? styleBorder
        : {};
    return (
        <div style={style} className={`${fontCss} ${borderCss} w-full`}>
            {data.wrapInContentArea ? (
                <Container>
                    <div
                        style={{ ...styleWidth, ...styleBorderForContentArea }}
                    >
                        {children}
                    </div>
                </Container>
            ) : (
                <div style={data.border?.isForContentArea ? styleBorder : {}}>
                    {children}
                </div>
            )}
        </div>
    );
};

export default WrapWithStyle;
